import { AUTH_SUCCESS, AUTH_ERROR, AUTH_NONE, AUTH_REDIRECT, AUTH_2FA_REQUIRED } from '../actions/authActions';
var initialState = {
  isAuthenticated: false,
  userId: null,
  token: null,
  errorMsg: null,
  pending: false,
  is2FARequired: false,
  shouldRedirect: false,
  location: {}
};
export default function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  switch (action.type) {
    case AUTH_SUCCESS:
    case AUTH_ERROR:
    case AUTH_NONE:
    case AUTH_REDIRECT:
    case AUTH_2FA_REQUIRED:
      return Object.assign({}, state, action.payload);
    default:
      {
        return state;
      }
  }
}